import { constantRoutes } from "@/router";
import { getRoutes } from "@/api/role";
import { getInfo } from "@/api/user";

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some((role) => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];

  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
export function mapRoutes(menuList = [], routes = []) {
  let temp = [];
  for (let i = 0; i < menuList.length; i++) {
    if (menuList[i].childs && menuList[i].childs.length >= 1) {
      temp = temp.concat(menuList[i].childs);
      console.log(temp, menuList[i], "00000");
    } else if (menuList[i].menuPath && /\S/.test(menuList[i].menuPath)) {
      let name = menuList[i].menuPath.slice(1).split("/");
      name = name.map((item) => {
        return item.replace(/^\S/, (s) => s.toUpperCase());
      });
      routes.push({
        path: menuList[i].menuPath.split("/")[1] || "/",
        component: (resolve) => require([`@/layout`], resolve),
        children: [
          {
            path: menuList[i].menuPath,
            name: name.join(""),
            hidden: menuList[i].status == 1 ? true : false,
            component: (resolve) =>
              require([`@/views${menuList[i].menuPath}`], resolve) || null,
            meta: {
              menuId: menuList[i].id,
              title: menuList[i].menuName,
              icon: menuList[i].menuIcon,
            },
          },
        ],
      });
    }
  }
  if (temp.length >= 1) {
    mapRoutes(temp, routes);
  }
  return routes;
}

const state = {
  routes: [],
  addRoutes: [],
  status: false,
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  SET_GTE_ROUTES: (state, status) => {
    state.status = status;
  },
};

const actions = {
  generateRoutes({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then((res) => {
          // if(res.baseInfo.userType == 1 || res.baseInfo.userType == 2){
          getRoutes({})
            .then((response) => {
              commit("SET_GTE_ROUTES", true);
              if (response.data.length > 0) {
                const router = mapRoutes(response.data);
                commit("SET_ROUTES", router);
                sessionStorage.setItem(
                  "menuList",
                  JSON.stringify(response.data || "[]")
                );
                console.log(router, "77777777777777777");
                resolve(router);
              } else {
                resolve([]);
              }
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  removeRoutes({ commit }) {
    return new Promise((resolve, reject) => {
      commit("SET_ROUTES", []);
      commit("SET_GTE_ROUTES", false);
      sessionStorage.removeItem("menuList");
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
